(function () {
  "use strict";

  // Object.values is not available on IE
  // Inspiration for this polyfill: https://github.com/es-shims/Object.values/blob/master/implementation.js
  if (typeof Object.values !== "function") {
    Object.values = function (o) {
      var values = [];
      for (var key in o) {
        if (o.hasOwnProperty(key)) {
          values.push(o[key]);
        }
      }
      return values;
    };
  }
})();
